import type { AuthenticatedRequest } from '@app/rest/rest.lib';
import { authenticatedRequest } from '@app/rest/rest.lib'

import type { IDomainEvent, IDomainEventId } from './domain-events.interface'

export type IDomainEventsResponse = {
  status: string
  domainEvents: IDomainEvent[]
  pageCount: number
  totalNumberOfRecords: number
}

export function getDomainEvents(
  pageNumber: number,
  recordsPerPage: number,
  pausedTime: Date,
  sources: string[],
  subjects: string[],
  types: string[],
): AuthenticatedRequest<IDomainEventsResponse> {
  let url = `/api/v2/domainEvents?`
  if (pageNumber) {
    url = `${url}&pageNumber=${pageNumber}`
  }

  if (recordsPerPage) {
    url = `${url}&recordsPerPage=${recordsPerPage}`
  }

  if (pausedTime) {
    const atTime = pausedTime.toISOString()
    url = `${url}&atTime=${atTime}`
  }

  if (sources && sources.length > 0) {
    const sourcesString = sources.map((it) => `&source=${it}`).join('')
    url = `${url}${sourcesString}`
  }

  if (subjects && subjects.length > 0) {
    const subjectsString = subjects.map((it) => `&subject=${it}`).join('')
    url = `${url}${subjectsString}`
  }

  if (types && types.length > 0) {
    const typesString = types.map((it) => `&type=${it}`).join('')
    url = `${url}${typesString}`
  }

  return authenticatedRequest<IDomainEventsResponse>({
    method: 'get',
    url,
  })
}

export type IDomainEventSourceResponse = {
  status: string
  sources: string[]
}

export function getDomainEventSources(): AuthenticatedRequest<
  IDomainEventSourceResponse
> {
  return authenticatedRequest<IDomainEventSourceResponse>({
    method: 'get',
    url: `/api/v2/domainEvent/sources`,
  })
}

export type IDomainEventSubjectResponse = {
  status: string
  subjects: string[]
}

export function getDomainEventSubjects(): AuthenticatedRequest<
  IDomainEventSubjectResponse
> {
  return authenticatedRequest<IDomainEventSubjectResponse>({
    method: 'get',
    url: `/api/v2/domainEvent/subjects`,
  })
}

export type IDomainEventTypeResponse = {
  status: string
  types: string[]
}

export function getDomainEventTypes(): AuthenticatedRequest<
  IDomainEventTypeResponse
> {
  return authenticatedRequest<IDomainEventTypeResponse>({
    method: 'get',
    url: `/api/v2/domainEvent/types`,
  })
}

export type IResubmitDomainEventResponse = {
  status: string
}

export function resubmitDomainEvent(
  domainEventId: IDomainEventId,
): AuthenticatedRequest<IResubmitDomainEventResponse> {
  return authenticatedRequest<IResubmitDomainEventResponse>({
    method: 'post',
    url: `/api/v2/domainEvent/resubmit`,
    data: { domainEventId },
  })
}
